// extracted by mini-css-extract-plugin
export default {"Accordion":"Accordion_shC1w","Accordion_description":"Accordion_description_xG71V","Accordion_items":"Accordion_items_Gly77"};